import { ComponentType } from 'react';

import { Element, Processor } from '@/features/html2react/types';

import Accordion from '../components/accordion';

interface AccordionProcessorElement extends Element {
  props: Element['props'];
}

const accordion: Processor<AccordionProcessorElement> = {
  priority: 10,
  name: 'accordion',
  test: ({ node }) => !!node.props?.className && node.props.className.includes('wp-block-erom-accordion'),
  processor: ({ node }) => {
    node.component = Accordion as ComponentType;

    return node;
  }
};

export default accordion;
